import { TableCell, TableRow } from "@mui/material";
import { getArrayIsNotEmpty } from "../../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const UnActiveCarRequestTableRow = ({
    carRequest
}) => {
    const navigate = useNavigate();

    const GetImageComponent = () => {
        let imgSource = '';

        const requestHaveImages = getArrayIsNotEmpty(carRequest.PartRequestImages);

        if (requestHaveImages) {
            imgSource = carRequest.PartRequestImages[0].small_part_request_image_url;
        };

        const ImageComponent = (
            <div style={styles.imageContainer}>
                <img
                    src={imgSource}
                    style={styles.imageStyle}
                />
            </div>
        );

        return imgSource
            ? ImageComponent
            : <div />
    };


    const getCreatedAtFromTodayText = () => {
        const createdAt = moment(carRequest.createdAt);

        return createdAt.format('DD.MM.YYYY.');
    };


    const handleOpenSingleRequestPage = (id) => {
        navigate(`/part-request/${id}`);
    };

    return (
        <TableRow
            onClick={() => handleOpenSingleRequestPage(carRequest.part_request_id)}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell>
                {GetImageComponent()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.title}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {getCreatedAtFromTodayText()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.partOfferCount}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.description}
            </TableCell>

        </TableRow>
    )
};


export default UnActiveCarRequestTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)"
    }
};